<template>
    <div id="app">
        <router-view/>
    </div>
</template>
<script>
    export default {
        name: 'app',

        data() {
            return {
                isHomePagge: true,
                activeKey: '',
                isLoading: false,
                routerConfig: [{
                    name: 'Home',
                    path: '/'
                }]
            }
        },
        created() {
            // 在页面加载时读取sessionStorage
            if (localStorage.getItem('store')) {
                this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem('store'))))
            }
            // 在页面刷新时将store保存到sessionStorage里
            window.addEventListener('beforeunload', () => {
                localStorage.setItem('store', JSON.stringify(this.$store.state))
            })
            const defR = this.$store.getters.getDefRouters
            if (defR.length > 0) {
                this.routerConfig = defR
            }
            // this.getUserInfo()
        },
        methods: {

        },
    }
</script>
<style lang="scss">
    * {
        margin: 0;
        padding: 0;
    }

    #app {
        /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
        /*-webkit-font-smoothing: antialiased;*/
        /*-moz-osx-font-smoothing: grayscale;*/
        /*text-align: center;*/
        color: #2c3e50;
        margin: 0;
        padding: 0;

        .app-content {
            padding-left: 8em;
            padding-right: 8em;
            min-width: 700px;
            width: 100%;
            height: auto;
        }
    }
</style>
